import { Component, Input } from "@angular/core";

@Component({
  selector: 'app-detail-notification',
  templateUrl: './detail-notification.component.html',
  styleUrls: ['./detail-notification.component.scss']
})
export class DetailNotificationComponent {
  @Input() public content: any;
  @Input() public detailedContent: any;

  public show = false;
}
